import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * The three filter option lists (season, competition, team), read from the
 * player's own matches, never a hardcoded list (issue #55). One home for
 * `Dashboard.jsx` (Record) and `RecordDashboardScreen.jsx` (#1147), so the two
 * screens cannot offer different options.
 *
 * Issue #271, deliberately ignored (do not "fix" this to an error state):
 * these populate the OPTIONAL contents of three dropdowns that already default
 * to "all". A failure costs the player the ability to narrow; it never puts a
 * wrong number on screen, and every figure is still the correct unfiltered
 * one. An error banner per dropdown would be three alarms for a degraded
 * convenience.
 *
 * `enabled` false makes no request (a coach or admin on Record has no player
 * profile). `reloadKey` refetches, the same retry hook Record's own loader
 * bumps.
 */
export function useMatchFilterOptions({ enabled = true, reloadKey = 0 } = {}) {
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [compOptions, setCompOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    api.get("/matches/seasons").then((r) => { if (!cancelled) setSeasonOptions(r.data?.seasons || []); }).catch(() => {});
    api.get("/matches/competitions").then((r) => { if (!cancelled) setCompOptions(r.data?.competitions || []); }).catch(() => {});
    api.get("/matches/teams").then((r) => { if (!cancelled) setTeamOptions(r.data?.teams || []); }).catch(() => {});
    return () => { cancelled = true; };
  }, [enabled, reloadKey]);

  return { seasonOptions, compOptions, teamOptions };
}

export default useMatchFilterOptions;
